import { ActListVM } from 'civil-status/view-models/research-form';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<ActListVM, keyof ActListVM>[] = [
  {
    id: 'idAct',
    label: 'ID',
  },
  {
    id: 'subject',
    label: 'Soggetto',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'typeAct',
    label: 'Tipologia Atto',
  },
  {
    id: 'date',
    label: 'Data formazione',
  },
  {
    id: 'dateLastUpdate',
    label: 'Data ultimo aggiornamento',
  },
  {
    id: 'nameOperator',
    label: 'Ultimo Operatore',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'idAnsc',
    label: 'ID ANSC',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
